<template>
  <div class="article_list">
    <div
      v-for="(i, index) in list"
      :key="index"
      class="article_item"
      @click="viewDetail(i.id)"
    >
      <div class="wrap">
        <div class="texts">
          <p
            class="title"
            v-html="i.title"
          />
          <p
            class="summary"
            v-html="i.summary"
          />
          <div class="counts">
            <div class="tag_box">
              <template v-if="i.tagList">
                <div
                  class="item_tag"
                  v-for="(item, index)  in i.tagList"
                  :key="item.id"
                  v-show="index < 2"
                >{{ item.tagName }}</div>
              </template>
            </div>
            <span class="count">{{ i.readCount }}人浏览</span>
            <span class="count">{{ i.artTime }}</span>
          </div>
        </div>
        <div
          v-if="i.cover"
          class="img_box"
        >
          <img
            :src="i.cover"
            alt=""
          >
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs } from 'vue'

export default defineComponent({
  name: 'ArticleList',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { emit }) {
    console.log("props.list", props.list);
    const router = useRouter()
    const viewDetail = (id) => {
      router.push({
        path: '/article/view',
        query: {
          id
        }
      })
    }
    return {
      viewDetail,
      ...toRefs(props)
    }
  }
})
</script>

<style scoped lang="scss">
.article_list {
  display: flex;
  flex-wrap: wrap;
  row-gap: 20px;
  margin-top: 20px;
}

.article_item {
  position: relative;
  padding: 16px;
  width: 590px;
  height: 140px;
  box-sizing: border-box;
  background: rgb(245, 247, 250);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 0px 10px #ccc;
  cursor: pointer;

  .wrap {
    display: flex;
    column-gap: 12px;
  }

  .texts {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .title {
    margin-bottom: 5px;
    font-size: 20px;
    font-weight: bold;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    word-break: break-all;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .summary {
    color: #999999;
    font-size: 12px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .img_box {
    width: 122px;
    height: 108px;
    overflow: hidden;
    border-radius: 5px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .counts {
    width: 100%;
    padding: 0% 5% 0px 0px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .tag_box {
      width: 40%;

      .item_tag {
        display: inline-block;
        line-height: 12px;
        font-size: 12px;
        padding: 2px 10px;
        box-sizing: border-box;
        background: #eee;
        border-radius: 20px;
        margin-right: 12px;
      }
    }
  }

  .count {
    font-size: 14px;
    color: #999;
  }

  .border {
    display: inline-block;
    margin: 0 10px;
    width: 1px;
    height: 10px;
    background: #BECADB;
  }

  &:nth-child(odd) {
    margin-right: 10px;
  }

  &:nth-child(even) {
    margin-left: 10px;
  }

  &:hover {
    box-shadow: 0 3px 18px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
    transition: all 0.3s;
  }
}
</style>
